export var TypeActionNotYetImplemented;
(function (TypeActionNotYetImplemented) {
    TypeActionNotYetImplemented["NotYetImplemented"] = "NotYetImplemented > NotYetImplemented";
    TypeActionNotYetImplemented["NotToBeImplemented"] = "NotYetImplemented > NotToBeImplemented";
})(TypeActionNotYetImplemented || (TypeActionNotYetImplemented = {}));
export var actionNotYetImplemented = function () { return ({
    type: TypeActionNotYetImplemented.NotYetImplemented,
}); };
export var actionNotToBeImplemented = function () { return ({
    type: TypeActionNotYetImplemented.NotToBeImplemented,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/not-yet-implemented/actionNotYetImplemented.ts
// module id = 569
// module chunks = 3